import {TaskService} from '../../libs/ui/src/index';
import {client} from '../apiService';
const _TaskService = new TaskService({client});
export {_TaskService as TaskService};
